export { default } from '@fhs/routing/src/routes/(drawer)/support/pypestream';
